import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ResultCard from "@/components/ResultCard";
import ResultCardSkeleton from "@/components/ResultCardSkeleton";
import StructuredData from "@/components/StructuredData";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";
import { useLotteryResults } from "@/hooks/useLotteryResults";

const TicaAyer = () => {
  const { data: results, isLoading } = useLotteryResults(1);
  const costaRicaResults = results?.costaRicaResults || [];

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toLocaleDateString('es-ES', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <>
      <StructuredData
        title="Resultados de Ayer - Tiempos JPS Costa Rica"
        description="Resultados de ayer de los Tiempos JPS de Costa Rica"
        results={costaRicaResults}
        country="costa-rica"
      />
      
      <div className="min-h-screen flex flex-col">
        <Navigation />
        
        <main className="flex-1 container mx-auto px-4 py-8">
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-costa-rica">
              🇨🇷 ¿Qué salió ayer en los Tiempos JPS?
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-2">
              Resultados de ayer de los Nuevos Tiempos de la JPS de Costa Rica, sorteo por sorteo
            </p>
            <p className="text-sm text-muted-foreground capitalize">{yesterdayStr}</p>
          </header>

          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Button asChild variant="outline">
              <Link to="/tiempos-tica-hoy">Hoy</Link>
            </Button>
            <Button asChild variant="default">
              <Link to="/que-salio-ayer-en-tiempos-jps">Ayer</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/tica-antier">Antier</Link>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {isLoading ? (
              <>
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
                <ResultCardSkeleton country="costa-rica" />
              </>
            ) : costaRicaResults.length > 0 ? (
              costaRicaResults.map((result, index) => (
                <ResultCard
                  key={index}
                  country="costa-rica"
                  {...result}
                  isPlayed={true}
                />
              ))
            ) : (
              <p className="text-center text-muted-foreground col-span-full">No hay resultados disponibles para ayer.</p>
            )}
          </div>
          {!isLoading && costaRicaResults.some((r) => r.isPlayed) && (
            <section className="mt-12 max-w-3xl mx-auto space-y-4">
              <h2 className="text-2xl font-bold">¿Qué salió ayer en los Tiempos JPS en cada sorteo?</h2>
              {costaRicaResults.filter((r) => r.isPlayed).map((r) => (
                <div key={r.time}>
                  <h3 className="font-semibold">¿Qué salió ayer en los Tiempos JPS a las {r.time}?</h3>
                  <p className="text-muted-foreground">
                    Ayer ({yesterdayStr}) a las {r.time} salió el número <strong>{r.number}</strong>.
                  </p>
                </div>
              ))}
            </section>
          )}
        </main>

        <Footer />
      </div>
    </>
  );
};

export default TicaAyer;
